import {Device} from "../../model/device";

export class LoginRequest extends Device {
  username: string;
  password: string;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/login/login-request.ts